import { ImageWMS } from "ol/source";
import { Group, Image as ImageLayer } from "ol/layer";

const urlEstadistica = import.meta.env.VITE_GEOSERVER_URL;

//sources
const granSMTIPMHConvergenteCenso2001 = new ImageWMS({
  url: `${urlEstadistica}/censo2001/wms`,
  params: { LAYERS: "gsmt_ipmh_censo_2001", grupo: "censo2001" },
  serverType: "geoserver",
  crossOrigin: "anonymous",
});

export const censo2001 = new Group({
  title: "Censo 2001",
  fold: "close",
  layers: [
    new Group({
      title: "Resultados generales",
      fold: "close",
      layers: [
        new ImageLayer({
          title: "Gran SMT - IPMH Convergente",
          visible: false,
          source: granSMTIPMHConvergenteCenso2001,
        }),
      ],
    }),
  ],
});
